// Fresh-deck construction, lifted out of documentSlice (TODO §12.4.3).
//
// Until §12 the only deck ever created was the store's own initial state, so this lived
// inside the reducer file. Now decks are minted from three places that have nothing to do
// with Redux — the `/` landing when storage is empty, "New document" on the documents home,
// and the import path's fallback — so the factory sits in `lib/` and `documentSlice` imports
// it, rather than the storage layer reaching into a slice.
//
// `crypto.randomUUID()`/`new Date()` here are fine: this is a plain factory, not a reducer.
// The reducer-purity rule (ARCHITECTURE §4) is about ids and clocks *inside* reducers.

import { DEFAULT_TRANSITION } from "@/lib/slide-transition";
import type { DeckDocument, SlideData } from "@/types/document";

export const DEFAULT_DECK_TITLE = "Untitled deck";

// A fresh slide is a single empty content window (TODO §4.1).
export function makeSlide(id: string): SlideData {
  return {
    id,
    title: "",
    source: "",
    archived: false,
    layout: "single",
    contents: [null],
  };
}

// A brand-new deck at the current schema, holding one empty slide. `meta.rev` starts at 0;
// the storage layer takes it from there (TODO §12.5.4).
export function createEmptyDeck(title = DEFAULT_DECK_TITLE): DeckDocument {
  const now = new Date().toISOString();
  return {
    schemaVersion: 15,
    id: crypto.randomUUID(),
    title,
    slides: [makeSlide(crypto.randomUUID())],
    styleSheet: { selectedSheet: "default", sheets: {} },
    transition: DEFAULT_TRANSITION,
    meta: { createdAt: now, updatedAt: now, rev: 0 },
  };
}
